﻿import React, { useState, useEffect } from 'react';
import { MobilePhase } from '../../models/Methods/mobile-phase';
import { CrudFunctions } from '../../utilities/crud-functions';
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';
import { ItemBasicInformation } from '../../models/item-basic-information';
import ItemBasicInformationDialog from '../ItemBasicInformationDialog';

import DataGrid, {
    Column,
    Selection,
    Button as ColumnButton,
    Toolbar,
    Item as ToolbarItem,
    Editing,
    Paging,
    LoadPanel
} from 'devextreme-react/data-grid';
import CheckBox from 'devextreme-react/check-box';
import Button from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';

let key = 0;

export interface Props {
    methodId: string;
    readOnly: boolean;
    onApply?: (mobilePhase: MobilePhase) => void;
    onCancel?: () => void;
}

export default function MobilePhaseEditor(props: Props) {
    //const [validMobilePhaseString, setValidMobilePhaseString] =
    //  useState<boolean>();

    const [mobilePhases, setMobilePhases] =
        useState<MobilePhase[]>();

    const [selectedMobilePhase, setSelectedMobilePhase] =
        useState<MobilePhase>();

    const [itemBasicInformationDialogVisible, setItemBasicInformationDialogVisible] =
        useState<boolean>();

    const [itemBasicInformation, setItemBasicInformation] =
        useState<ItemBasicInformation>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, [props.methodId]);

    key++;

    return (
        <div>
            <div className="pw-form-unit">
                <CheckBox text="Isocratic" />
            </div>

            <div className="pw-form-unit pw-margin-top-1">
                <DataGrid height="10rem"
                    wordWrapEnabled={true}
                    keyExpr="mobilePhaseId"
                    dataSource={mobilePhases ? mobilePhases : []}
                    onSelectionChanged={onMobilePhaseSelectionChanged}
                    onRowValidating={onMobilePhaseRowValidating}
                    onRowRemoving={onMobilePhaseRowRemoving}
                    showRowLines={true}

                    rowAlternationEnabled={true}
                    showBorders={true} >

                    <LoadPanel enabled={true} />
                    <Selection mode='single' />
                    <Paging enabled={false} />

                    <Column name="bc0" type="buttons" width='6rem'>
                        <ColumnButton hint="information" icon="info"
                            onClick={onMobilePhaseInfoButtonClick} />
                        <ColumnButton name="edit" />
                        <ColumnButton name="save" />
                        <ColumnButton name="delete" />
                    </Column>

                    <Column dataField='mobilePhaseString' caption="phase" dataType="string" width='6rem' />
                    <Column dataField='solventUnits' caption="ratio" dataType="number" width='8rem' />
                    <Column dataField='solventName' caption="value" dataType="string" />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Mobile Phases</div>
                            </div>
                        </ToolbarItem>

                        {!props.readOnly &&
                            <ToolbarItem location='after' name="addRowButton" />
                        }

                    </Toolbar>

                    {!props.readOnly &&
                        <Editing mode="row"
                            useIcons={true}
                            allowAdding={true}
                            allowUpdating={true}
                            allowDeleting={true}
                            newRowPosition="last" />
                    }

                </DataGrid>
            </div>



            {/*

            <div className="pw-form-unit">
                <TextBox id="mobilePhaseString" className="textbox"
                    placeholder='NA' onValueChanged={onMobilePhaseStringValueChanged}
                    value={mobilePhase && mobilePhase.mobilePhaseString ? mobilePhase.mobilePhaseString : undefined} />
            </div>

                <div className="pw-form-unit pw-comp-10">
                    <div className="pw-form-unit-label">Mobile Phase Type</div>
                    <SelectBox id="mobilePhaseType" className="textbox"
                        dataSource={mobilePhaseTypes ? mobilePhaseTypes : []}
                        valueExpr='id' displayExpr="name"
                        onValueChanged={onValueChanged}
                        placeholder="NA"
                        value={mobilePhase && mobilePhase.mobilePhaseType ? mobilePhase.mobilePhaseType : undefined} />
                </div>
                */}


            {/*
                <div className="pw-form-unit pw-comp-10">
                    <div className="pw-form-unit-label">Measurement</div>
                    <TextBox id="solventMeasurement" className="textbox"
                        readOnly={true} placeholder='NA'
                        value={mobilePhase && mobilePhase.solventMeasurementString ?
                            mobilePhase.solventMeasurementString : undefined} />
                </div>

                <div className="pw-form-unit pw-comp-30">
                    <div className="pw-form-unit-label">Solvent Name</div>
                    <TextBox id="solventName" className="textbox"
                        readOnly={true} placeholder='NA'
                        value={mobilePhase && mobilePhase.solventName ? mobilePhase.solventName : undefined} />
                </div>
            </div>

            {mobilePhase && mobilePhase.buffer &&
                <div className="pw-comp-row">
                    <div className="pw-form-unit pw-comp-10">
                        <div className="pw-form-unit-label">Buffer Measurement</div>
                        <TextBox id="bufferMeasurementString" className="textbox"
                            readOnly={true} placeholder='NA'
                            value={mobilePhase && mobilePhase.bufferMeasurementString ? mobilePhase.bufferMeasurementString : undefined} />
                    </div>

                    <div className="pw-form-unit pw-comp-30">
                        <div className="pw-form-unit-label">Buffer</div>
                        <TextBox id="buffer" className="textbox"
                            readOnly={true} placeholder='NA'
                            value={mobilePhase && mobilePhase.buffer ? mobilePhase.buffer : undefined} />
                    </div>
                </div>
            }

            <div className="pw-comp-row">
                <div className="pw-form-unit pw-row-button-08">
                    <CheckBox id="aq" text="Aq"
                        value={mobilePhase && mobilePhase.aq ? mobilePhase.aq : false} />
                </div>
            </div>

            <div className="pw-comp-row">
                <div className="pw-centered-buttons-container">
                    <Button id="applySelectionButton"
                        className="pw-button" type="success"
                        text="Apply" height='2.6em'
                        onClick={onApplyClick} />

                    <Button id="cancelButton"
                        className="pw-button" text="Cancel" type="normal"
                        height='2.6em' onClick={onCancelClick} />
                </div>
            </div>
            */}


            {itemBasicInformationDialogVisible &&
                <DialogPopup visible={itemBasicInformationDialogVisible}
                    onHiding={hideItemBasicInformationDialog}
                    title="Item Basic Information"
                    width='25rem'
                    height='21rem'
                    dragEnabled={false}
                    resizeEnabled={false}>
                    <ItemBasicInformationDialog initInformation={itemBasicInformation}
                        onOkClick={hideItemBasicInformationDialog}
                        key={`IBI${key}`} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    async function onMobilePhaseSelectionChanged(e: any) {
        if (e.selectedRowsData && e.selectedRowsData.length > 0)
            setSelectedMobilePhase(e.selectedRowsData[0]);
    }

    async function onMobilePhaseRowValidating(e: any) {
        if (e.oldData) {
            let mobilePhase = e.oldData as MobilePhase;

            if (mobilePhase) {
                let updatedMobilePhase = { ...mobilePhase, ...e.newData };

                updateMobilePhase(updatedMobilePhase)
                    .catch((res) => {
                        showMessage(res, ModalMessageType.Error, "Error Updating Mobile Phase");
                    });
            }
        }
        else {
            if (e.newData) {
                let mobilePhase = e.newData as MobilePhase;

                if (mobilePhase) {
                    mobilePhase.methodId = props.methodId;

                    await insertMobilePhase(mobilePhase)
                        .then(() => {
                            getMobilePhases();
                        })
                        .catch((res) => {
                            showMessage(res, ModalMessageType.Error, "Error Inserting Mobile Phase");
                        });
                }
            }
        }

    }

    async function onMobilePhaseRowRemoving(e: any) {
        console.log("onMobilePhaseRowRemoving");
        console.log(e);


        //deleteMobilePhase
    }


    async function getMobilePhases() {
        if (props.methodId) {
            await CrudFunctions.getData(`methods/mobilephases/${props.methodId}`)
                .then(data => {

                    console.log("Mobile phases...");
                    console.log(data);
                    setMobilePhases(data);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Mobile Phases");
                });
        }
    }

    async function insertMobilePhase(mobilePhase: MobilePhase) {
        return await CrudFunctions.postData("methods/mobilePhase", mobilePhase);
    }

    async function updateMobilePhase(mobilePhase: MobilePhase) {
        return await CrudFunctions.putData("methods/mobilePhase", mobilePhase);
    }

    async function deleteMobilePhase(mobilePhaseId: string) {
        return await CrudFunctions.deleteData(`methods/mobilephase/${mobilePhaseId}`);
    }

    async function getAllData() {
        await Promise.all([
            getMobilePhases()
        ])

    }

    /*
    function onMobilePhaseStringValueChanged(e: any) {
        setMobilePhase({ ...mobilePhase, mobilePhaseString: e.value })
    }
 
    function parseMobilePhaseString() {
        if (!mobilePhase)
            return;
 
        if (!mobilePhase.mobilePhaseString)
            return;
 
        let editedMobilePhaseString = mobilePhase.mobilePhaseString;
        let editedMobilePhase = mobilePhase;
 
        if (editedMobilePhaseString.includes("(aq)")) {
            editedMobilePhase.aq = true;
            editedMobilePhaseString = editedMobilePhaseString.replace("(aq)", "");
        }
 
        else if (editedMobilePhaseString.includes(" in water")) {
            editedMobilePhase.aq = true;
            editedMobilePhaseString = editedMobilePhaseString.replace(" in water", "");
        }
        else
            editedMobilePhase.aq = false;
 
        //first look for buffer
 
        let bufferIdx = editedMobilePhaseString.search(/\+\s*\d+[.]*\d*(%|mM)/i);
 
        if (bufferIdx > -1) {
            let bufferString = editedMobilePhaseString.substring(bufferIdx).replace('+','');
            editedMobilePhaseString = editedMobilePhaseString.substring(0, bufferIdx - 1);
 
            if (bufferString) {
                let measurement = getMeasurementFromString(editedMobilePhase.buffer);
 
                editedMobilePhase.bufferMeasurementString = measurement;
 
                if (measurement)
                    bufferString = bufferString.replace(measurement, '');
 
                editedMobilePhase.buffer = bufferString;
            }
        }
        */

    //let idx = editedMobilePhaseString.search(/\d+[.]?\d*\s*(%|mM)\s*/im);

    /*
    if (idx > -1) {
        let solventNameString = editedMobilePhaseString.substring(idx);
        editedMobilePhaseString = editedMobilePhaseString.substring(0, idx - 1);
 
        if (solventNameString) {
            let measurement = getMeasurementFromString(editedMobilePhase.solventName);
 
            editedMobilePhase.solventMeasurementString = measurement;
 
            if (measurement)
                solventNameString = solventNameString.replace(measurement, '');
 
            editedMobilePhase.solventName = solventNameString;
        }
    }
    
    setValidMobilePhaseString(true);
}
 
function getMeasurementFromString(phrase: string) {
    const regex = new RegExp('\\d+[.]?\\d*\\s*(%|mM)\\s*', 'i');
 
    let matches;
    
    while ((matches = regex.exec(phrase)) !== null) {
        // This is necessary to avoid infinite loops with zero-width matches
        if (matches.index === regex.lastIndex) {
            regex.lastIndex++;
        }
 
        //temp for testing:
        // The result can be accessed through the `m`-variable.
        matches.forEach((match, groupIndex) => {
            console.log(`Found match, group ${groupIndex}: ${match}`);
        });
 
        if (matches && matches.length > 0) {
            return matches[0];
        }
    }
 
    return '';
}
*/


    function onMobilePhaseInfoButtonClick(e: any) {
        if (e.row && e.row.data) {
            const mobilePhase = e.row.data as MobilePhase;

            if (mobilePhase) {
                setSelectedMobilePhase(mobilePhase);

                let itemInformation: ItemBasicInformation = {
                    rowPointer: mobilePhase.mobilePhaseId,
                    createTimestamp: mobilePhase.createTimestamp,
                    lastModifiedTimestamp: mobilePhase.modifyTimestamp,
                    createUser: mobilePhase.createUser,
                    modifyUser: mobilePhase.modifyUser
                };

                setItemBasicInformation(itemInformation);
                showItemBasicInformationDialog();
            }

        }
    }

    function showItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(true);
    }

    function hideItemBasicInformationDialog() {
        setItemBasicInformationDialogVisible(false);
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}
